export const selectOngageUnsubscribeState = state =>
  state.ongageUnsubscribeReducer

export const selectLoadingList = state =>
  selectOngageUnsubscribeState(state)?.loadingList

export const selectErrorList = state =>
  selectOngageUnsubscribeState(state)?.errorList

export const selectLoadingUnsubscribe = state =>
  selectOngageUnsubscribeState(state)?.loadingUnsubscribe

export const selectErrorUnsubscribe = state =>
  selectOngageUnsubscribeState(state)?.errorUnsubscribe

export const selectAuthToken = state =>
  selectOngageUnsubscribeState(state)?.data?.auth?.token

export const selectObfuscatedEmail = state =>
  selectOngageUnsubscribeState(state)?.data?.auth?.obfuscatedEmail

export const selectCampaigns = state =>
  selectOngageUnsubscribeState(state)?.data?.profile?.campaigns

export const selectUnsubscribeSuccess = state =>
  selectOngageUnsubscribeState(state)?.data?.unsubscribe?.success

export const getAccessToken = state => selectAuthToken(state)?.access
